'use strict';
import {SuperAlign} from "@blax-modules/generic/resources/js/segments/SuperAlign";
import {waitLoad} from "@blax-modules/base-front-end/resources/js/utilities/load";
export class Plans {
    constructor() {
        waitLoad().then(() => {
            this.stickyHeaderElement = document.querySelector('.plans-tabs-ctn');
            this.stickyElements = document.querySelectorAll('.plans-sticky-header');
            this.tabs = document.querySelectorAll('[data-tab]');
            this.stickyTabs = document.querySelectorAll('[data-sticky-tab]');
            this.curTargetId;
            this.isMobile = (window.innerWidth < 1220);
            //this.initiateCollapse();
            this.isFirstStickyEnabled = false;
            this.hasPassedTheBoxes = false;
            this.bottomOfPage = false;
            if(!this.stickyHeaderElement) {
                return;
            }
            if(this.stickyHeaderElement && this.stickyElements){
                this.initStickyHeader();
                this.bindAll();
            }
            const that = this;
            setTimeout(()=> {
                if(!that.isMobile)
                    this.resetTabsHeight(true);
            }, 250)
            window.addEventListener('resize', () => {
                that.isMobile = (window.innerWidth < 1220);
                if(!that.isMobile)
                    that.resetTabsHeight(true);
                else
                    that.resetTabsHeight(false);
            });
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const getUrlParam = urlParams.get('currentTab')
            setTimeout(()=> {
                if (getUrlParam) {
                    if (getUrlParam === "4") {
                        this.tabs[0].click();
                    } else if (getUrlParam === "2") {
                        this.tabs[1].click();
                    } else if (getUrlParam === "3") {
                        this.tabs[1].click();
                    }
                }
            }, 0);
            window.addEventListener('scroll', () => {
                const planElementHeight = document.querySelector('.plans-tabs.active').getBoundingClientRect().height;
                const introText = document.querySelector('.container-intro-text').getBoundingClientRect().height
                const tabCtn = document.querySelector('.plans-tabs-ctn').getBoundingClientRect().height
                if(document.querySelector('.plans-sticky-header.visible')){
                    const tabsHeight = document.querySelector('.plans-sticky-header.visible').getBoundingClientRect().height
                    if(document.querySelector('.gdpr-message.visible')) {
                        const gdprElementHeight = document.querySelector('.gdpr-message.visible').getBoundingClientRect().height;
                        console.log(planElementHeight + introText + tabsHeight + tabCtn + gdprElementHeight < document.documentElement.scrollTop,
                            planElementHeight, introText, tabsHeight, tabCtn, gdprElementHeight, document.documentElement.scrollTop)
                        if(planElementHeight + introText + tabsHeight + tabCtn + gdprElementHeight < document.documentElement.scrollTop) {
                            document.querySelector('.plans-sticky-header.visible').classList.add('disabled');
                        } else {
                            document.querySelector('.plans-sticky-header.visible').classList.remove('disabled');
                        }
                    } else {
                        if(planElementHeight + introText + tabsHeight + tabCtn < document.documentElement.scrollTop) {
                            document.querySelector('.plans-sticky-header.visible').classList.add('disabled');
                        } else {
                            document.querySelector('.plans-sticky-header.visible').classList.remove('disabled');
                        }
                    }
                }

            });
        })
        const superAlign = new SuperAlign('.js-text-normalize');
        superAlign.mobileEnabled = true;
        superAlign.init();
    }
    resetTabsHeight(isDesktop) {
        const navHeight = document.querySelector('.site-header').offsetHeight;
        for (let x = 0; x < this.stickyElements.length; x++) {
            const curTabs = this.stickyElements[x].querySelectorAll('.plans-sticky-header-tab');
            for (let y = 0; y < curTabs.length; y++) {
                if (isDesktop)
                    curTabs[y].style.height = navHeight + 'px';
                else
                    curTabs[y].style.height = 'auto';
            }
        }
    }
    initStickyHeader(){
        const observer = new window.IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                this.isFirstStickyEnabled = false;
                this.hasPassedTheBoxes = false;
                this.hideStickyHeader(false, false);
                return
            }
            this.isFirstStickyEnabled = true;
            if(!this.hasPassedTheBoxes)
                this.showStickyHeader(false);
        }, {
            root: null,
            threshold: .5, // set offset 0.1 means trigger if atleast 10% of element in viewport
        })
        observer.observe(this.stickyHeaderElement)

        const observerTitle = new window.IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                this.hasPassedTheBoxes = false
                if(this.isFirstStickyEnabled) {
                    this.showStickyHeader(false);
                    this.isFirstStickyEnabled = true
                }
                return
            }
            this.hasPassedTheBoxes = true
            this.hideStickyHeader(false);
        }, {
            root: null,
            threshold: .5, // set offset 0.1 means trigger if atleast 10% of element in viewport
        })
        observerTitle.observe(document.querySelector('.plans-product-box-ctn'))

        const everyComparisonTabs = document.querySelectorAll('.comparaison_tab');
        for(let x = 0; x < everyComparisonTabs.length; x++){
            const observerTab = new window.IntersectionObserver(([entry]) => {
                if (entry.isIntersecting && this.isFirstStickyEnabled) {
                    this.hideStickyHeader(false, false);
                    return
                } else if(!this.isFirstStickyEnabled){
                    return
                }
                this.showStickyHeader(true);
            }, {
                root: null,
                threshold: 0.25, // set offset 0.1 means trigger if atleast 10% of element in viewport
            })
            observerTab.observe(everyComparisonTabs[x])
        }

    }
    showStickyHeader(reachedComparaisonTable){
        if(reachedComparaisonTable && this.isFirstStickyEnabled ){
            this.stickyElements[1].classList.add('visible');
        }else if(!reachedComparaisonTable) {
            this.stickyElements[0].classList.add('visible');
        }
    }
    hideStickyHeader(reachedComparaisonTable, hasFirstTabBeenReached){
        if(reachedComparaisonTable){
            this.stickyElements[0].classList.remove('visible');
        } else if(!this.isFirstStickyEnabled) {
            this.stickyElements[0].classList.remove('visible');
            this.stickyElements[1].classList.remove('visible');
        } else if(this.hasPassedTheBoxes = true && document.documentElement.scrollTop > 1000) {
            //TODO: Ajouter un algo qui va calculer une hauteur de scroll relative aux éléments de la page et non une valeur absolue
            this.stickyElements[1].classList.remove('visible');
            this.stickyElements[0].classList.remove('visible');
        } else{
            this.stickyElements[1].classList.remove('visible');
        }
    }
    initiateCollapse(){
        const allCollapses = document.querySelectorAll('[data-collapse]');
        for (let i = 0; i < allCollapses.length; i++) {
                allCollapses[i].classList.toggle("active");
                const content = allCollapses[i].nextElementSibling;
                if (content.style.maxHeight){
                    content.style.maxHeight = null;
                } else {
                    content.style.maxHeight = content.scrollHeight + 2 + "px";
                }
        }
    }
    bindAll() {
        for(var i = 0; i < this.tabs.length ; i++) {
            let that = this;
            this.tabs[i].addEventListener('click', function(curElement){
                that.clearTabs();
                that.clearStickyTabs();
                that.curTargetId = curElement.target.getAttribute('data-tab');
                for(let x = 0; x < that.tabs.length; x++){
                    if(that.tabs[x].getAttribute('data-tab') == that.curTargetId){
                        if(that.stickyTabs[x])
                            that.changeStickyTabs(that, that.stickyTabs[x]);
                        that.changeTabs(that, that.tabs[x]);
                    }
                }
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }, false);
        }
        //Init sticky tabs
        for(var i = 0; i < this.stickyTabs.length ; i++) {
            let that = this;
            this.stickyTabs[i].addEventListener('click', function(curElement){
                that.clearTabs();
                that.clearStickyTabs();
                that.curTargetId = curElement.target.getAttribute('data-sticky-tab');
                for(let x = 0; x < that.stickyTabs.length; x++){
                    if(that.stickyTabs[x].getAttribute('data-sticky-tab') == that.curTargetId){
                        if(that.tabs[x])
                            that.changeTabs(that, that.tabs[x]);
                        that.changeStickyTabs(that, that.stickyTabs[x]);
                    }
                }
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }, false);
        }

    }

    clearTabs(fromSticky){
        for(var i = 0; i < this.tabs.length ; i++) {
            this.tabs[i].classList.remove('active');
            var id = this.tabs[i].getAttribute('data-tab');
            document.getElementById(id).classList.remove('active');
        }
    }
    changeTabs(curClass, curElement) {
        curElement.classList.add('active');
        document.getElementById(curClass.curTargetId).classList.add('active');
    }
    clearStickyTabs(fromSticky){
        for(var i = 0; i < this.stickyTabs.length ; i++) {
            this.stickyTabs[i].classList.remove('active');
        }
    }
    changeStickyTabs(curClass, curElement,) {
        curElement.classList.add('active');
        document.getElementById(curClass.curTargetId).classList.add('active');
    }

}
